<template>
    <div>
        <div v-if="financialStripeBillingAddress" class="mb-5rem">
            <div class="lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp">
                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        Name
                    </div>

                    <input ref="inputField"
                           type="text"
                           name="name"
                           v-validate="'required'"
                           v-model="billingInfo.name"
                           data-vv-as="Name"
                           :class="{'lw-brand-border': errors.first('name') }"
                           class="learnworlds-input-solid-light learnworlds-input 
                                  learnworlds-input-normal learnworlds-element"
                           placeholder="Name"/>

                    <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                        {{ errors.first('name') }}
                    </span>
                </div>
                
                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        Street
                    </div>

                    <input ref="inputField"
                           type="text"
                           name="line1"
                           v-validate="'required'"
                           data-vv-as="Street"
                           v-model="billingInfo.address.line1"
                           :class="{'lw-brand-border': errors.first('line1') }"
                           class="learnworlds-input-solid-light learnworlds-input 
                                  learnworlds-input-normal learnworlds-element"
                           placeholder="Street"/>

                    <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                        {{ errors.first('line1') }}
                    </span>
                </div>
                
                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        Postcode
                    </div>

                    <input ref="inputField"
                           type="text"
                           name="postal_code"
                           v-validate="'required'"
                           data-vv-as="Postcode"
                           v-model="billingInfo.address.postal_code"
                           :class="{'lw-brand-border': errors.first('postal_code') }"
                           class="learnworlds-input-solid-light learnworlds-input 
                                  learnworlds-input-normal learnworlds-element"
                           placeholder="Postcode"/>

                    <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                        {{ errors.first('postal_code') }}
                    </span>
                </div>

                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        City
                    </div>

                    <input ref="inputField"
                           type="text"
                           name="city"
                           v-validate="'required'"
                           data-vv-as="City"
                           v-model="billingInfo.address.city"
                           :class="{'lw-brand-border': errors.first('city') }"
                           class="learnworlds-input-solid-light learnworlds-input 
                                  learnworlds-input-normal learnworlds-element"
                           placeholder="City"/>

                    <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                        {{ errors.first('city') }}
                    </span>
                </div>

                <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        Country
                    </div>
                    
                    <div class="select-wrapper">
                        <select name="country"
                                v-validate="'required'"
                                data-vv-as="Country"
                                v-model="billingInfo.address.country"
                                :class="{'lw-brand-border': errors.first('country') }"
                                class="learnworlds-input-solid-light learnworlds-input 
                                       learnworlds-input-normal learnworlds-element">

                            <option value="" disabled selected>
                                Select a Country
                            </option>

                            <option v-for="(country, index) in countries"
                                    :key="index"
                                    :value="country.value">

                                {{ country.name }}
                            </option>
                        </select>
                    </div>

                    <span class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                        {{ errors.first('country') }}
                    </span>
                </div>
            </div>
        </div>


        <div class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp">
            <div class="col flex-item span_12_of_12-all no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Card number
                </div>
                <div ref="cardNumber"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element"></div>
                <div ref="cardNumberError"
                     class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                </div>
            </div>
        </div>
        <div class="lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp">
            <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    Expiration date
                </div>
                <div ref="cardExpiry"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element"></div>
                <div ref="cardExpiryError"
                     class="learnworlds-main-text learnworlds-main-text-small learnworlds-element"></div>
            </div>
            <div class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp no-padding mb-2rem">
                <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                    CVC
                </div>
                <div ref="cardCvc"
                     class="learnworlds-input-solid-light learnworlds-input 
                            learnworlds-input-normal learnworlds-element"></div>
                <div ref="cardCvcError"
                     class="learnworlds-main-text learnworlds-main-text-small learnworlds-element"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import StripeHandler from './../libs/StripeHandler';
    import {mapState} from 'vuex';

    export default {
        props: {
            'stripeApi': {
                type: Object,
                default() {
                    return null;
                }
            },
            'stripeElements': {
                type: Object,
                default() {
                    return null;
                }
            }
        },
        computed: {
            ...mapState([
                'financialStripeBillingAddress',
                'countries'
            ]),
        },
        data() {
            return {
                cardElements: {},
                billingInfo: {
                    address: {
                        country: '',
                        city: '',
                        line1: '',
                        postal_code: ''
                    },
                    name: '',
                },
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.cardElements['cardNumber'] = this.stripeElements.create('cardNumber');
                this.cardElements['cardCvc'] = this.stripeElements.create('cardCvc');
                this.cardElements['cardExpiry'] = this.stripeElements.create('cardExpiry');
                this.cardElements['cardNumber'].mount(this.$refs['cardNumber']);
                this.cardElements['cardCvc'].mount(this.$refs['cardCvc']);
                this.cardElements['cardExpiry'].mount(this.$refs['cardExpiry']);

                for (const element in this.cardElements) {
                    this.cardElements[element].on('change', (e) => {
                        const cardElement = this.$refs[element];
                        const displayError = this.$refs[`${element}Error`];
                        
                        if (e.error) {
                            cardElement.classList.add('lw-brand-border');
                            displayError.textContent = e.error.message;
                        } else {
                            cardElement.classList.remove('lw-brand-border');
                            displayError.textContent = '';
                        }
                    });
                }
            })
        },
        beforeDestroy() {
            for (const element in this.cardElements) {
                this.cardElements[element].unmount();
                this.cardElements[element].destroy();
            }
        },
        methods: {
            createStripeElement(element, type) {
                // const el = document.createElement('div');
                // const stripeEl =
                // this._element.mount(el)
                // // this.$children cannot be used because it expects a VNode :(
                // this.$el.appendChild(el)
            },
            validate() {
                const validateCardFragments = this.validateCardFragments();
                return new Promise((resolve,reject)=>{
                    this.$validator.validateAll().then( result => {
                        if(!result || !validateCardFragments){
                            reject();
                        }
                        resolve();
                    });
                });
            },
            validateCardFragments() {
                var validates = true;
                for (const element in this.cardElements) {
                    if (!this.cardElements[element]._complete) {
                        this.cardElements[element].focus();
                        validates = false;
                        return false;
                    }

                }
                return validates;
            },
            getCardElements() {
                return this.cardElements;
            },
            getBillingInfo() {
                return this.financialStripeBillingAddress 
                    ? this.billingInfo
                    : null;
            }
        }
    }
</script>
